// Implements: F-UIX-019, F-RPT-009
/**
 * "Exportar CSV" of a platform report (owner 2026-10-19), in the v3 style: a secondary button with
 * the download glyph (v3 `.btn` + `ic('download')`), busy while its file comes, and the last
 * refusal under it as an alert. Pure presentation: the download is the container's.
 */

import type { ReactElement } from "react";

import { useTranslation } from "../../../shared/i18n";
import { Button } from "../../../shared/ui/atoms/Button";
import { Icon } from "../../../shared/ui/atoms/Icon";
import styles from "./ExportCsvButton.module.css";

export interface ExportCsvButtonProps {
  readonly busy: boolean;
  readonly failure: string | null;
  readonly onExport: () => void;
}

export function ExportCsvButton({ busy, failure, onExport }: ExportCsvButtonProps): ReactElement {
  const { t } = useTranslation();
  return (
    <div className={styles.export}>
      <Button variant="secondary" type="button" loading={busy} disabled={busy} onClick={onExport}>
        <Icon name="download" size="sm" />
        {t("reports.export.csv")}
      </Button>
      {failure === null ? null : (
        <p className={styles.failure} role="alert">
          {failure}
        </p>
      )}
    </div>
  );
}
